import axios from "axios";
import { retrieveToken } from "./utils/localStorage";
import { toastContainer, dismissToast } from "./utils/toast";
import { ROLE_CHANGED_RELOGIN_MESSAGE } from "./utils/constants";
import * as actionCreators from "./modules/actions/index";
import { store } from './index';
import * as url from './utils/url';
import moment from 'moment';

const hostname = window.location.hostname;
// console.log('hostname',hostname)

axios.defaults.headers.post["Content-Type"] = "application/json";

axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Credentials"] = true;

let localBool = hostname.indexOf("localhost") > -1 || hostname.indexOf("ngrok") > -1;
let devBool = hostname.indexOf("devportal") > -1  || hostname.indexOf("trivvy") > -1 ;
let qaBool = hostname.indexOf("qaportal") > -1 

let local;
if (localBool) {
  local = `${window.location.protocol}//localhost:8090`;
  // local = `${window.location.protocol}//devapi.ouroffice.io`;
} else if (devBool) {
  local = `${window.location.protocol}//devapi.ouroffice.io`;
} else if (qaBool) {
  local = `${window.location.protocol}//qaapi.ouroffice.io`;
} else {
  local = `${window.location.protocol}//api.ouroffice.io`;
}
// local = `${window.location.protocol}//api.ouroffice.io`;
console.log(local)
const instance = axios.create({
  // baseURL: `${window.location.protocol}//devapi.ouroffice.io`,
  // baseURL: ENV === PROD ? `${window.location.protocol}//api.ouroffice.io` :
  //     ENV === QA ? local :
  //     ENV === DEV ? `${window.location.protocol}//devapi.ouroffice.io`: null
  // for dev : 'https://devapi.ouroffice.io'
  baseURL: local,
  // `${window.location.protocol}//devapi.ouroffice.io`:
  // baseURL: `${window.location.protocol}//portalapi.ouroffice.io`,
  // baseURL: `${window.location.protocol}//localhost:8090`
});

// console.log('inst - ',instance.baseURL)

instance.all = axios.all;
instance.spread = axios.spread;

// instance.defaults.headers.common['Authorization'] = `Bearer ${retrieveToken()}`;
instance.interceptors.request.use(config => {
  const token = `Bearer ${retrieveToken()}`;
  config.headers.Authorization = token;
  config.headers.Pragma = "no-cache";
  config.headers["Access-Control-Allow-Origin"] = "*";
  config.headers["Access-Control-Allow-Credentials"] = true;
  // reset inactivity timers on every axios call
  // resetInactivityTimers();

  return config;
});

// Surfaces a clear, app-wide message when the backend rejects a request because
// the user's role was changed under them (their session still carries the old
// role). Fires on any 401 whose message is the role-changed message or
// "...not allowed to perform this operation". Only shows the toast; the user is
// told to log out and back in. A fixed toast id keeps parallel failing calls
// from stacking duplicate toasts.
const ROLE_CHANGED_TOAST_ID = "role-changed-relogin";

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      const data = error.response.data;
      const msg =
        data && data.errors && data.errors.message ? data.errors.message : "";
      if (
        msg &&
        (msg === ROLE_CHANGED_RELOGIN_MESSAGE ||
          String(msg).toLowerCase().indexOf("not allowed to perform this operation") > -1)
      ) {
        toastContainer(ROLE_CHANGED_RELOGIN_MESSAGE, "error", ROLE_CHANGED_TOAST_ID);
      }
    }
    return Promise.reject(error);
  }
);

// Inactivity logout logic
let warningTimeout, logoutTimeout;
const WARNING_MINUTES = 9 * 60 * 1000; // 9 minutes
const LOGOUT_MINUTES = 10 * 60 * 1000; // 10 minutes

let warningToastVisible = false;

// Check if user is actually authenticated
const isUserAuthenticated = () => {
  // Check token in localStorage
  const token = localStorage.getItem("AutherizationToken");
  if (!token || token === "sdjnsc" || token === null || token === "") {
    return false;
  }

  // Check Redux store for user profile
  try {
    const state = store.getState();
    return state.user.profile && state.user.profile.autherizationToken ? true : false;
  } catch (e) {
    return false;
  }
};

// Clear all inactivity timers
const clearInactivityTimers = () => {
  clearTimeout(warningTimeout);
  clearTimeout(logoutTimeout);
  dismissToast();
  warningToastVisible = false;
};

const performLogout = () => {
  // Clear timers immediately to prevent multiple logout attempts
  clearInactivityTimers();

  const state = store.getState();
  const user = state.user.profile;

  if (user && user.login_time) {
    const { login_time, geo } = user;
    const logout_time = moment();
    const duration = moment.duration(logout_time.diff(moment(login_time)));

    const payload = {
      login_time,
      logout_time,
      org_id: user.organizationId._id,
      org_name: user.organizationId.name,
      geo,
      duration: duration._data,
      miliseconds: duration._milliseconds,
    };

    // Dispatching Redux logout action
    store.dispatch(actionCreators.logout());

    // Calling logout API endpoint
    axios
      .put(url.logoutUser, payload)
      .then(({ data }) => {
        console.log('LOGGED OUT DUE TO INACTIVITY');
      })
      .catch((error) => {
        console.log('Logout API call failed, but proceeding with logout');
      })
      .finally(() => {
        window.location.href = "/";
      });
  } else {
    store.dispatch(actionCreators.logout());
    window.location.href = "/";
  }
};

// const resetInactivityTimers = () => {
//   // Clear existing timers
//   clearTimeout(warningTimeout);
//   clearTimeout(logoutTimeout);

//   // Only set timers if user is authenticated
//   if (!isUserAuthenticated()) {
//     return;
//   }

//   if (warningToastVisible) {
//     dismissToast();
//     warningToastVisible = false;
//   }

//   warningTimeout = setTimeout(() => {
//     // Check authentication
//     if (!isUserAuthenticated()) {
//       return;
//     }
//     toastContainer("Your session will expire in 1 minute due to inactivity.", "warning");
//     warningToastVisible = true;
//   }, WARNING_MINUTES);

//   logoutTimeout = setTimeout(() => {
//     // Check authentication
//     if (!isUserAuthenticated()) {
//       return;
//     }
//     toastContainer("You have been logged out due to inactivity.", "error");
//     setTimeout(() => {
//       performLogout();
//     }, 5000);
//   }, LOGOUT_MINUTES);
// };


export default instance;
